import React from 'react';
import Page from '../Page';
import LoadingBanner from "../../components/LoadingBanner";
import { Outlet, useLocation, useNavigate, useParams, useSearchParams, generatePath } from "react-router-dom";
import TalentCommitmentLevelModal from './TalentCommitmentLevelModal';
import {useAuth} from "../../providers/AuthProvider";
import InfoTooltip from "../../components/InfoTooltip";
import TalentVersionUpdate2025 from "../talent-dashboard/TalentVersionUpdate2025";

class TalentPortal extends Page {

    static path = '/talent';

    static contractsPath() {
        return `/talent/contracts`
    }
    static dashboardPath() {
        return `/talent/dashboard`
    }

    static jobBoardPath() {
        return `/talent/job-board`
    }

    static preferencesPath() {
        return `/talent/work-preferences`
    }
    static adminProjectsListPath() {
        return {
            pathname: '/talent/manager/opportunities',
            key: TB.uuid()
        }
    }
    static adminTalentListPath() {
        return {
            pathname: '/talent/manager/talent-vetting',
            key: TB.uuid()
        }
    }

    static adminTalentTeamsListPath() {
        return {
            pathname: '/talent/manager/teams/all',
            key: TB.uuid()
        }
    }
    static projectsListPath(status = 'All') {
        return generatePath(`/talent/projects/:status`, { status: TB.slugify(status) })
    }
    static teamsListPath(status = 'All') {
        return generatePath(`/talent/teams/:status`, { status: TB.slugify(status) })
    }

    static supplierClientProjectsListPath(status = 'All') {
        return generatePath(`/supplier/projects/:status`, { status: TB.slugify(status) })
    }

    constructor(props, context) {
        super(props, context);

        let auth = context?.auth;

        this.state = {
            hasTodoItems: auth
                && (auth.mustSignAgreement() || !auth.hasCompletedProfile()),
            // pages: auth ? this.context?.auth?.portalPages() : [],
        }
    }


    navLinks() {
        if (this.context?.auth?.canManageTalent()) {
            return [
                { label: 'Opportunities', path: this.constructor.adminProjectsListPath() },
                { label: 'Talent Vetting', path: this.constructor.adminTalentListPath() },
                { label: 'Teams', path: this.constructor.adminTalentTeamsListPath() },
            ]
        }

        // if (!this.context?.auth?.hasCompletedProfile()) {
        //     return [
        //         {label: 'Profile', path: TalentApplication.path},
        //     ]
        // }
        if (this.context.auth?.isTalentSupplierResource()) {
            return [
                { label: 'Projects', path: this.constructor.projectsListPath() },
                { label: 'Profile', path: '/talent/application' },
                { label: 'Teams', path: this.constructor.teamsListPath(), active: 'teams' },
            ]
        }

        if (this.context.auth?.isClientInvitedResource({ is_on_talent_marketplace: false })) {
            return [
                { label: 'Projects', path: this.constructor.projectsListPath() },
                { label: 'Profile', path: '/talent/application' },
            ]
        }

        let baseFeaturesDisabled = false;
        if (this.context.auth?.isTalent()
            && this.context.auth?.isApplicationApproved()
            && !this.context.auth?.isProfileApproved()) {
            baseFeaturesDisabled = true;
        }
        return [
            { label: 'Projects', path: this.constructor.projectsListPath(), disabled: baseFeaturesDisabled },
            { label: 'Profile', path: '/talent/application' },
            { label: 'Contracts', path: this.constructor.contractsPath(), disabled: baseFeaturesDisabled },
            { label: 'Jobs', path: this.constructor.jobBoardPath(), active: 'job-board', disabled: baseFeaturesDisabled },
            { label: 'Teams', path: this.constructor.teamsListPath(), active: 'teams', disabled: baseFeaturesDisabled },
            { label: 'Preferences', path: this.constructor.preferencesPath() },
        ]
    }

    renderTopBar() {
        let auth = this.context?.auth;
        if (!auth) {
            return <div />;
        }

        return (
            <div className="nav-container">
                <div className="nav-info">

                    {auth.isTalent() && (
                        <button onClick={() => this.props.navigate('dashboard')}
                            className="dashboard-home-btn hidden md:flex">
                            <i className="fa fa-th text-lg text-white" />
                            <p className="text-white mb-0 mt-2">
                                {TB.trans('talent.dashboard.nav_info')}
                            </p>
                        </button>
                    )}

                    <div className="talent-portal-nav">

                        {this.navLinks().map(({ label, path, active, disabled }) => (
                            <div key={`nav-${label}`}>
                                <div
                                    id={`nav-${label}`}
                                    className={TB.mapClass("clickable talent-portal-nav-item", {
                                        active: this.props.location.pathname.indexOf(active || TB.slugify(TB.toLower(label))) > 0,
                                        'feature-disabled': disabled
                                    })}
                                    onClick={() => {
                                        if (!disabled) {
                                            this.props.navigate(path)
                                        }
                                    }}>
                                    {label}
                                </div>
                                {disabled && (
                                    <InfoTooltip target={`nav-${label}`} placement="bottom" type="white">
                                        <p className="text-sm text-danger mb-0 px-2 pt-2 pb-1">
                                            Not Available Yet!
                                        </p>
                                        <p className="text-xs px-2 pb-2 pt-0">
                                            Profile Needs Approval
                                        </p>
                                    </InfoTooltip>
                                )}
                            </div>
                        ))}

                    </div>

                    <div className="dashboard-logout-button hidden md:flex">
                        <button type="button" onClick={() => TB.auth().logout()} className="btn btn-outline-light">
                            Log out
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    renderTodoMessage() {
        return (
            <div className="nav-alert">
                <p>{TB.trans('talent.dashboard.nav_alert')}</p>
            </div>
        )
    }

    render() {

        if (!this.context.auth) {
            return <div className="talent-portal-page">
                <LoadingBanner/>
            </div>
        }

        return (
            <div className={'talent-portal-page'}>

                {this.renderTopBar()}

                <Outlet />


            </div>
        );
    }
}

const TalentPortalLayout = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const {auth, isLoaded} = useAuth();
    const [searchParams, setSearchParams] = useSearchParams();
    const params = useParams();

    let queryParams = Object.fromEntries(new URLSearchParams(searchParams));

    return (
        <>
            <TalentPortal
                navigate={navigate} location={location}
                queryParams={{ ...queryParams, ...(params || {}) }}
            />

            {auth && auth.isActive() && auth.isTalent() && !auth.isTalentSupplierResource() && (
                <TalentCommitmentLevelModal />
            )}
            {auth.isTalent() && auth.isApplicationApproved() &&
                TB.isDefined(auth.talent_commitment_level) &&
                auth.has_full_time_employment_interest !== null && (
                <TalentVersionUpdate2025/>
            )}
        </>
    )
}

export default TalentPortal;

export {
    TalentPortalLayout
}